<template>
  <div>
    <select
      :multiple="multiple"
      :class="{ multipleSelect: multiple }"
      v-if="options"
      class="uk-select"
      v-model="model"
    >
      <option value selected>Select</option>
      <option
        :value="option.value"
        v-for="option in $root.cache.getOptions[input.id]"
        >{{ option.label }}
      </option>
    </select>
    <template v-else>loading</template>
  </div>
</template>

<script>
export default {
  name: "leadStatus",
  data() {
    return {
      model: this.value,
      options: null
    };
  },
  props: ["input", "form", "value", "multiple"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  mounted() {
    if (this.input.id > 0) {
      this.options = this.$root.cache.getOptions[this.input.id];
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style>
.multipleSelect {
  height: 300px !important;
}
</style>
